import { ApplicationConfig } from '@angular/core';
import { addSpotterProviders } from '@spotter/providers/spotter-providers';
import { routes } from './app.routes';
import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    addSpotterProviders(routes, environment),
  ]
};
